// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-style {
  box-shadow: 6px 6px 9px #b6bfbf, -6px -6px 9px #edfbfafa !important;
  border-radius: 4px !important;
  font-size: 14px !important;
  text-align: center !important;
  cursor: pointer !important;
  -webkit-user-select: none !important;
          user-select: none !important;
  font-family: myfont !important;
  color: #ffffff !important;
  background-color: #001489 !important;
  border-color: #001489 !important;
}

.button-style:disabled {
  box-shadow: none;
  color: #ffffff !important;
  background-color: gray !important;
  border-color: gray !important;
}

.button-style:hover {
  box-shadow: 9px 9px 16px #919a9c, -9px -9px 16px #ffffff !important;
  border: 1px solid #0068b3 !important;
  color: #ffcc00 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/button/ButtonView.css"],"names":[],"mappings":"AAAA;EACE,mEAAmE;EACnE,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,oCAA4B;UAA5B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,mEAAmE;EACnE,oCAAoC;EACpC,yBAAyB;AAC3B","sourcesContent":[".button-style {\n  box-shadow: 6px 6px 9px #b6bfbf, -6px -6px 9px #edfbfafa !important;\n  border-radius: 4px !important;\n  font-size: 14px !important;\n  text-align: center !important;\n  cursor: pointer !important;\n  user-select: none !important;\n  font-family: myfont !important;\n  color: #ffffff !important;\n  background-color: #001489 !important;\n  border-color: #001489 !important;\n}\n\n.button-style:disabled {\n  box-shadow: none;\n  color: #ffffff !important;\n  background-color: gray !important;\n  border-color: gray !important;\n}\n\n.button-style:hover {\n  box-shadow: 9px 9px 16px #919a9c, -9px -9px 16px #ffffff !important;\n  border: 1px solid #0068b3 !important;\n  color: #ffcc00 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
